const FitAssistantStatusEnum = Object.freeze({
  NoSelection: 'noselection',
  Confirmed: 'confirmed',
  Unconfirmed: 'unconfirmed',
  NoFit: 'nofit',
  RackMounting: 'rackmounting',
});

export default FitAssistantStatusEnum;
